import Joi from '@hapi/joi'

export const MobileAdvanceRequestDetailReportSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Select Operation Entity`,
        "any.required": `Operation Entity required`
    }),
    divisionID: Joi.number().invalid(0).required().label("Collection Point").messages({
        "any.invalid": `Please select valid Collectionpoint`,
        "any.required": `Collectionpoint required`
    }),
    // month: Joi.string().invalid("").required().label("Month").required().messages({
    //     "any.invalid": `Please select Month`,
    //     "any.required": `Month required`
    // }),
}

